export const arrowBarRightIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-arrow-bar-right"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8zm-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5z"
    />
  </svg>
);

export const arrowBarLeftIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-arrow-bar-left"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5zM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5z"
    />
  </svg>
);

export const playIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-play-fill"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
  </svg>
);

export const personFillIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-person-fill"
    viewBox="0 0 16 16"
  >
    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
  </svg>
);

export const questionIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-question"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
  </svg>
);

export const xIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-x"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
    />
  </svg>
);

export const checkIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-check2"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"
    />
  </svg>
);

export const lockIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-lock-fill"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z" />
    <path
      fillRule="evenodd"
      d="M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"
    />
  </svg>
);

export const plusIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-plus"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"
    />
  </svg>
);

export const minusIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-dash"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);

export const chevronUpIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-chevron-compact-up"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"
    />
  </svg>
);

export const chevronDownIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-chevron-compact-down"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
    />
  </svg>
);

export const caretUpIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-caret-up"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M3.204 11L8 5.519 12.796 11H3.204zm-.753-.659l4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z"
    />
  </svg>
);

export const caretDownIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-caret-down"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M3.204 5L8 10.481 12.796 5H3.204zm-.753.659l4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z"
    />
  </svg>
);

export const exportGraphIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-clipboard-data"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
    />
    <path
      fillRule="evenodd"
      d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
    />
    <path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" />
  </svg>
);

export const exportIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-clipboard-minus"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
    />
    <path
      fillRule="evenodd"
      d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3.1zm-3 5.5a.5.5 0 0 1 .5 -.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 2.5a.5.5 0 0 1 .5 -.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 2.5a.5.5 0 0 1 .5 -.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 2.5a.5.5 0 0 1 .5 -.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);

export const inquiryIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-info"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z" />
    <circle cx="8" cy="4.5" r="1" />
  </svg>
);

export const inquiry2Icon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-info-circle"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    />
    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z" />
    <circle cx="8" cy="4.5" r="1" />
  </svg>
);

export const googleIcon = (
  <svg
    className="social-logo"
    viewBox="0 0 256 262"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <path
      d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      fill="#4285F4"
    ></path>
    <path
      d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      fill="#34A853"
    ></path>
    <path
      d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
      fill="#FBBC05"
    ></path>
    <path
      d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      fill="#EA4335"
    ></path>
  </svg>
);

export const fbIcon = (
  <svg
    className="social-logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 216 216"
    color="#ffffff"
  >
    <path
      fill="#ffffff"
      d="
          M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9
          11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1
          11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2
          15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3
          11.9-11.9V11.9C216 5.3 210.7 0 204.1 0z"
    ></path>
  </svg>
);

export const gearIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-gear"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M8.837 1.626c-.246-.835-1.428-.835-1.674 0l-.094.319A1.873 1.873 0 0 1 4.377 3.06l-.292-.16c-.764-.415-1.6.42-1.184 1.185l.159.292a1.873 1.873 0 0 1-1.115 2.692l-.319.094c-.835.246-.835 1.428 0 1.674l.319.094a1.873 1.873 0 0 1 1.115 2.693l-.16.291c-.415.764.42 1.6 1.185 1.184l.292-.159a1.873 1.873 0 0 1 2.692 1.116l.094.318c.246.835 1.428.835 1.674 0l.094-.319a1.873 1.873 0 0 1 2.693-1.115l.291.16c.764.415 1.6-.42 1.184-1.185l-.159-.291a1.873 1.873 0 0 1 1.116-2.693l.318-.094c.835-.246.835-1.428 0-1.674l-.319-.094a1.873 1.873 0 0 1-1.115-2.692l.16-.292c.415-.764-.42-1.6-1.185-1.184l-.291.159A1.873 1.873 0 0 1 8.93 1.945l-.094-.319zm-2.633-.283c.527-1.79 3.065-1.79 3.592 0l.094.319a.873.873 0 0 0 1.255.52l.292-.16c1.64-.892 3.434.901 2.54 2.541l-.159.292a.873.873 0 0 0 .52 1.255l.319.094c1.79.527 1.79 3.065 0 3.592l-.319.094a.873.873 0 0 0-.52 1.255l.16.292c.893 1.64-.902 3.434-2.541 2.54l-.292-.159a.873.873 0 0 0-1.255.52l-.094.319c-.527 1.79-3.065 1.79-3.592 0l-.094-.319a.873.873 0 0 0-1.255-.52l-.292.16c-1.64.893-3.433-.902-2.54-2.541l.159-.292a.873.873 0 0 0-.52-1.255l-.319-.094c-1.79-.527-1.79-3.065 0-3.592l.319-.094a.873.873 0 0 0 .52-1.255l-.16-.292c-.892-1.64.902-3.433 2.541-2.54l.292.159a.873.873 0 0 0 1.255-.52l.094-.319z"
    />
    <path
      fillRule="evenodd"
      d="M8 5.754a2.246 2.246 0 1 0 0 4.492 2.246 2.246 0 0 0 0-4.492zM4.754 8a3.246 3.246 0 1 1 6.492 0 3.246 3.246 0 0 1-6.492 0z"
    />
  </svg>
);

export const eye = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-eye"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
    />
    <path
      fillRule="evenodd"
      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
    />
  </svg>
);

export const eyeSlash = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-eye-slash"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
    <path
      fillRule="evenodd"
      d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z"
    />
  </svg>
);

export const menuIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-list"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);

export const profileIcon = (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    className="bi bi-person"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6 5c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
    />
  </svg>
);

export const FX = (
  <svg viewBox="0 0 360 307.15" xmlSpace="preserve" fill="currentColor">
    <path d="M138.24 196.61h42.21v11.81H150.8v16h26.67v11.8H150.8v26.38h-12.56v-65.99zM198.1 239.67l-15.6-22.22h14.4l8.28 12.54h.65l7.81-12.54h14.87l-16 22.22 16 23H214.2l-8.56-12.92H205l-8.28 12.92h-14.41l15.79-23zM179.35 162.79c-.64 0-1.28-.14-1.85-.43L45 97.61a4.22 4.22 0 01-1.95-5.63 4.204 4.204 0 012.8-2.25L178.9 56.94c.66-.16 1.34-.16 2 0l134.2 33.07c2.26.55 3.65 2.83 3.1 5.09a4.175 4.175 0 01-2.28 2.8l-134.75 64.47c-.57.28-1.19.42-1.82.42zM59.1 95.11l120.23 58.76L301.6 95.36l-121.74-30L59.1 95.11z" />
    <path d="M179.28 178.48c-.67 0-1.33-.16-1.93-.46L10.18 94.35a4.342 4.342 0 01-1.94-5.82 4.347 4.347 0 012.87-2.28l168-40c.66-.16 1.34-.16 2 0L349.77 86.2a4.34 4.34 0 013.21 5.23 4.35 4.35 0 01-2.29 2.88l-169.48 83.72c-.6.3-1.26.45-1.93.45zM24.73 91.93l154.57 77.36 156.74-77.43L180.1 54.93l-155.37 37z" />
  </svg>
);

export const PH = (
  <svg viewBox="0 0 360 330.45" xmlSpace="preserve" fill="currentColor">
    <path d="M289.19 198.66H246.1v-33.57c-.02-3.32-1.69-6.42-4.45-8.26v-44.87h8.26a25.66 25.66 0 0017.93-7.38c4.7-4.68 7.36-11.04 7.37-17.67V73.05c.02-3.14-2.52-5.7-5.66-5.72h-52.99V51.57c0-2.42.8-7.89-7.6-8.14h-1c-8.52.25-7.81 5.72-7.81 8.14v15.76h-36.17V51.57c0-2.42.36-7.89-8.16-8.14h-1c-8.39.25-7.84 5.72-7.84 8.14v15.76h-55.6c-3.12.04-5.62 2.6-5.59 5.72v13.86a24.488 24.488 0 007.31 17.67 25.092 25.092 0 0017.8 7.38h8.52v45.25a9.436 9.436 0 00-4.07 7.88v33.57H71.66c-2.39 0-4.32 1.93-4.32 4.32s1.93 4.32 4.32 4.32h217.53c2.39 0 4.32-1.93 4.32-4.32s-1.93-4.32-4.32-4.32zm-178.25-95.48c-4.4.07-8.63-1.68-11.7-4.83a15.713 15.713 0 01-4.83-11.44V76.1h172v10.81a16.07 16.07 0 01-4.7 11.44c-3.14 3.13-7.4 4.87-11.83 4.83H110.94zm114.52 53.9a9.775 9.775 0 00-4.19 8v33.58h-81v-33.57c0-3.36-1.73-6.48-4.58-8.26v-44.87h89.8l-.03 45.12zM132.71 286.83v-66h23.39c3.03-.03 6.03.49 8.88 1.52 2.66.95 5.1 2.41 7.2 4.29 4.27 3.81 6.67 9.28 6.6 15 .1 5.76-2.31 11.29-6.6 15.13-2.1 1.88-4.55 3.34-7.2 4.29a25.596 25.596 0 01-8.88 1.52h-10.84v24.25h-12.55zm23.61-36.07c3.29 0 5.76-.93 7.44-2.77 1.62-1.72 2.52-4 2.51-6.37 0-1.16-.2-2.31-.61-3.4a7.721 7.721 0 00-1.86-2.91 9.221 9.221 0 00-3.11-2c-1.4-.52-2.88-.76-4.37-.73h-11.06v18.18h11.06zM186.71 220.81h12.18v18.53l-.75 8.21h.75a15.05 15.05 0 015.62-5.3c2.51-1.4 5.35-2.12 8.23-2.08 5.89 0 10.24 1.72 13.07 5.16 2.83 3.44 4.23 8.14 4.22 14.11v27.39h-12.17v-25.91c0-3.13-.75-5.52-2.24-7.14a8.013 8.013 0 00-6.23-2.45c-1.55-.03-3.09.34-4.46 1.06-1.3.71-2.43 1.71-3.3 2.91-.91 1.3-1.58 2.75-2 4.28-.47 1.7-.7 3.45-.69 5.21v22h-12.23v-65.98z" />
  </svg>
);

export const SR = (
  <svg viewBox="0 0 360 376.55" xmlSpace="preserve" fill="currentColor">
    <path d="M159.63 195.74V73.56a9.933 9.933 0 00-1.27-4.7v-3.94a4.29 4.29 0 00-4.25-4.33h-.45V44.7c.02-1.03-.81-1.88-1.84-1.9h-.07c-1.03.05-1.85.87-1.9 1.9v15.89h-.26a4.29 4.29 0 00-4.32 4.26v4.01a10.05 10.05 0 00-1.27 4.7v122.18c-13.63 4.32-21.17 18.86-16.86 32.49s18.86 21.17 32.49 16.86 21.17-18.86 16.86-32.49a25.885 25.885 0 00-16.86-16.86zm-7.88 41.58c-9.39.16-17.13-7.32-17.29-16.7a17.019 17.019 0 0112.21-16.61c.41.15.84.24 1.27.25h7.75c.48-.01.95-.1 1.4-.25h.13c8.97 2.9 13.89 12.53 10.99 21.5a17.083 17.083 0 01-16.46 11.81zM216.97 195.87V73.56c.03-1.54-.41-3.04-1.27-4.32v-4.32a4.29 4.29 0 00-4.25-4.33H211V44.7c0-1.05-.86-1.91-1.91-1.91s-1.91.86-1.91 1.91v15.89h-.38a4.29 4.29 0 00-4.32 4.26V69.24a7.463 7.463 0 00-1.27 4.32v122.18c-13.51 4.45-20.86 19.01-16.41 32.53 4.45 13.51 19.01 20.86 32.53 16.41a25.753 25.753 0 0017.7-24.39c-.04-11.22-7.35-21.11-18.06-24.42zm-7.87 41.45c-9.39.24-17.19-7.17-17.43-16.56-.2-7.71 4.82-14.58 12.22-16.75.45.14.92.23 1.4.25h7.63a7.2 7.2 0 001.52-.25h.13c8.97 2.9 13.89 12.53 10.99 21.5a17.083 17.083 0 01-16.46 11.81zM161.85 332.04c-2.77.01-5.53-.4-8.18-1.2-2.57-.79-4.99-2-7.16-3.6-2.2-1.63-4.11-3.6-5.67-5.85-1.69-2.47-2.97-5.2-3.81-8.07l11.8-4.62c.75 3.11 2.33 5.96 4.56 8.26 2.28 2.22 5.38 3.41 8.56 3.27 1.27 0 2.53-.17 3.76-.5 1.16-.31 2.25-.81 3.25-1.48.94-.63 1.72-1.47 2.28-2.45.58-1.04.87-2.21.84-3.4.02-1.14-.21-2.27-.66-3.32a7.658 7.658 0 00-2.18-2.77c-1.23-.99-2.57-1.83-4-2.49a60.75 60.75 0 00-6.09-2.49l-4.05-1.52c-1.89-.65-3.71-1.49-5.44-2.49-1.83-1.03-3.51-2.3-5-3.78a18.829 18.829 0 01-3.67-5.21c-.99-2.12-1.48-4.44-1.44-6.78-.02-2.5.5-4.97 1.53-7.24 1.03-2.25 2.53-4.26 4.38-5.9a20.4 20.4 0 016.78-4 28.221 28.221 0 0117.48-.09c2.25.78 4.35 1.93 6.22 3.41 1.62 1.29 3.01 2.83 4.14 4.56.96 1.47 1.74 3.05 2.33 4.7l-11.06 4.62a11.79 11.79 0 00-3.4-5 9.714 9.714 0 00-6.74-2.22c-2.4-.09-4.77.57-6.78 1.89a5.77 5.77 0 00-2.7 4.94c.02 1.99.98 3.85 2.6 5a28.02 28.02 0 008.27 4l4.19 1.39c2.51.86 4.95 1.92 7.29 3.18a22.57 22.57 0 015.67 4.28c1.57 1.64 2.8 3.57 3.63 5.68.88 2.34 1.3 4.83 1.25 7.33.08 3.1-.63 6.16-2.08 8.9-1.33 2.4-3.15 4.49-5.35 6.13a23.508 23.508 0 01-7.35 3.6c-2.59.82-5.28 1.27-8 1.33zM193.45 285.37h11.44v6.27h.74c.58-1.11 1.34-2.13 2.24-3 .94-.93 1.98-1.73 3.11-2.41 1.17-.69 2.41-1.24 3.71-1.65 1.29-.42 2.64-.64 4-.64 1.4-.03 2.8.14 4.15.51 1.04.29 2.02.75 2.92 1.34l-3.26 10.79a10.7 10.7 0 00-2.45-.88c-1.09-.24-2.2-.34-3.31-.32-1.57-.01-3.13.33-4.55 1-1.35.64-2.54 1.57-3.49 2.73a13.03 13.03 0 00-2.23 4.13c-.54 1.66-.81 3.4-.79 5.14v22.25h-12.23v-45.26z" />
  </svg>
);

export const VT = (
  <svg viewBox="0 0 360 343.21" xmlSpace="preserve" fill="currentColor">
    <path d="M131.79 232.85h13.57l13.74 39.74 2.43 8.49h.73l2.61-8.49 14.33-39.74h13.57l-24.26 66H155.3l-23.51-66zM203.18 264.02h-8v-10.33h8v-13.83h12.17v13.83h11.16v10.33h-11.16v18.05c-.01 1.01.1 2.02.34 3 .19.88.62 1.69 1.25 2.33.94 1.04 2.31 1.6 3.71 1.52.85.03 1.7-.08 2.51-.33.63-.22 1.22-.51 1.78-.87l3.44 10.6c-1.47.69-3.02 1.2-4.61 1.52-1.79.35-3.61.53-5.44.51-2.11.03-4.21-.34-6.18-1.09a12.91 12.91 0 01-4.6-3c-2.91-2.82-4.36-6.82-4.37-12v-20.24zM289.19 203.65h-63.32v-8.64c-.06-7.71-6.29-13.94-14-14h-5.85v-62.66h18.58c9.83 0 17.85-7.85 18.06-17.68V49.82a4.29 4.29 0 00-4.26-4.32H122.77c-2.38.02-4.3 1.94-4.33 4.32v50.6c.04 9.94 8.12 17.96 18.06 17.93h21.1v61.91c-.02.26.02.52.13.76h-7c-7.73 0-14 6.27-14 14v8.64H71.66c-2.42 0-4.39 1.97-4.39 4.39s1.97 4.39 4.39 4.39h65.09v1.52a4.29 4.29 0 004.25 4.33h80.55c2.38-.03 4.3-1.95 4.32-4.33v-1.52h63.32c2.42 0 4.39-1.97 4.39-4.39s-1.97-4.39-4.39-4.39v-.01zM127.1 54.15h106.91v10.8l-106.91-.26V54.15zm9.41 55.56a9.444 9.444 0 01-9.41-9.28V73.47l106.92.12v27c-.1 5.11-4.3 9.19-9.41 9.15l-88.1-.03zm80.59 99.92h-71.7v-14.62a5.26 5.26 0 015.31-5.21h61.18a5.16 5.16 0 015.21 5.11V209.63z" />
  </svg>
);

export const PB = (
  <svg viewBox="0 0 360 378.23" xmlSpace="preserve" fill="currentColor">
    <path d="M131.5 334.55v-66h23.43c3.03-.02 6.03.49 8.88 1.52 2.65.96 5.1 2.41 7.2 4.29 2.05 1.85 3.7 4.09 4.85 6.6a21.295 21.295 0 010 17c-1.15 2.51-2.8 4.75-4.85 6.6-2.1 1.88-4.55 3.33-7.2 4.29a25.596 25.596 0 01-8.88 1.52H144.1v24.25l-12.6-.07zm23.6-36.05c3.28 0 5.76-.93 7.43-2.77 1.64-1.71 2.56-4 2.57-6.37 0-1.16-.2-2.31-.6-3.4a7.721 7.721 0 00-1.86-2.91 9.221 9.221 0 00-3.11-2c-1.4-.52-2.88-.76-4.37-.73H144.1v18.17l11 .01zM185.52 268.52h12.18v19.83l-.75 6.46h.75c1.27-2.06 3.07-3.75 5.2-4.89 2.69-1.42 5.7-2.11 8.74-2 2.87-.01 5.71.6 8.32 1.8 2.63 1.2 5.01 2.9 7 5 2.06 2.21 3.69 4.8 4.78 7.62a27.355 27.355 0 010 19.36c-1.09 2.82-2.71 5.4-4.78 7.61-1.99 2.1-4.37 3.8-7 5-2.61 1.2-5.45 1.81-8.32 1.8-3.04.11-6.05-.58-8.74-2a13.722 13.722 0 01-5.2-4.89h-.75v5.44h-11.43v-66.14zm23.58 56.35c1.58 0 3.15-.31 4.61-.92a12.26 12.26 0 003.85-2.59c1.16-1.16 2.07-2.54 2.7-4.05a14.54 14.54 0 000-10.7 12.76 12.76 0 00-2.7-4.06c-1.11-1.1-2.41-1.98-3.85-2.58-1.46-.61-3.03-.92-4.61-.92-1.57-.01-3.14.29-4.6.87a11.53 11.53 0 00-3.85 2.54 12.332 12.332 0 00-2.7 4.06c-1.37 3.5-1.37 7.38 0 10.88.62 1.52 1.54 2.9 2.7 4.06 1.1 1.1 2.41 1.96 3.85 2.53 1.46.58 3.02.88 4.6.88zM293.51 247.32a4.29 4.29 0 01-4.26 4.32H71.66c-2.39 0-4.32-1.93-4.32-4.32s1.93-4.32 4.32-4.32h65l-1.18-107.34a8.792 8.792 0 015.34-8.13l.25-53a52.43 52.43 0 012.16-9l.64-2.16c.13-.32.21-.66.25-1-1.5-2.11-2.3-4.65-2.28-7.24 0-6.36 4.45-11.45 9.91-11.45s9.92 5.09 9.92 11.45c.07 3.72-1.62 7.26-4.57 9.53-.12.26-.12.64-.25.89l-.76 2.67c-.81 2.41-1.44 4.88-1.91 7.38l-.13 2.79v48.82a8.845 8.845 0 016.61 8.52l1.15 107.31h37.29l1.09-107.38a8.84 8.84 0 016.74-8.52l-.25-51.87c-.39-2.29-1.28-5.08-1.91-7.37l-.76-2.16c-.13-.38-.13-.77-.26-1.15a12.007 12.007 0 01-4.45-9.53c0-6.36 4.45-11.45 9.92-11.45s9.92 5.09 9.92 11.45c.02 2.65-.83 5.24-2.42 7.37.13.13.13.38.25.64l.77 2.54c.9 2.84 1.62 5.72 2.16 8.65l.25 3.3v50.1a8.858 8.858 0 015.22 8l-1.15 107.31h65c2.36-.01 4.28 1.91 4.29 4.27v.08z" />
  </svg>
);

export const HB = (
  <svg viewBox="0 0 360 396.15" xmlSpace="preserve" fill="currentColor">
    <path d="M289.19 258.93h-6.61v-11.06a6.41 6.41 0 00-2-4.7V55.77c.02-1.38-.33-2.74-1-3.94.21-.39.3-.84.25-1.28v-1c0-2.93-2.54-5.22-5.85-5.22h-188c-3.31 0-5.73 2.29-5.73 5.22v1c-.03.3.01.61.13.89a7.909 7.909 0 00-1.27 4.33v187.4a6.41 6.41 0 00-2 4.7v11.06h-5.34a4.328 4.328 0 00-4.53 4.12 4.328 4.328 0 004.12 4.53c.14.01.28.01.42 0H289.2a4.328 4.328 0 004.12-4.53 4.353 4.353 0 00-4.13-4.12zm-23.52-15.76a6.41 6.41 0 00-2 4.7v11.06H95.94v-11.06a6.41 6.41 0 00-2-4.7V55.77h171.73v187.4zM126.01 285.74h12.55v26.38h28v-26.38h12.54v66h-12.56v-27.82h-28v27.85h-12.53v-66.03zM190.98 285.74h12.18v19.88l-.75 6.46h.75c1.28-2.06 3.07-3.74 5.2-4.9 2.69-1.41 5.7-2.1 8.74-2 2.87-.01 5.71.6 8.32 1.79 2.63 1.2 5.01 2.9 7 5 2.06 2.21 3.69 4.79 4.78 7.61a27.382 27.382 0 010 19.37c-1.09 2.82-2.72 5.4-4.78 7.61-1.99 2.1-4.36 3.8-7 5-2.61 1.19-5.45 1.8-8.32 1.8-3.04.11-6.05-.58-8.74-2a13.952 13.952 0 01-5.2-4.89h-.75v5.44h-11.43v-66.17zm23.61 56.34c1.58.01 3.15-.3 4.61-.91 1.45-.59 2.78-1.46 3.9-2.55 1.16-1.16 2.08-2.54 2.71-4.06 1.35-3.44 1.35-7.25 0-10.69-.63-1.52-1.55-2.89-2.71-4.06-1.11-1.1-2.41-1.98-3.85-2.58-1.46-.61-3.03-.93-4.61-.92-1.57-.01-3.14.29-4.6.87a11.53 11.53 0 00-3.85 2.54 12.525 12.525 0 00-2.69 4.05 14.74 14.74 0 000 10.89c.62 1.52 1.53 2.9 2.69 4.06 1.1 1.09 2.41 1.95 3.85 2.53 1.45.56 2.99.84 4.55.83z" />
  </svg>
);

export const UB = (
  <svg viewBox="0 0 360 396.15" xmlSpace="preserve" fill="currentColor">
    <path d="M289.42 258.12h-6.61v-11.06a6.41 6.41 0 00-2-4.7V76.97a7.99 7.99 0 00-1-3.94c.21-.39.3-.83.25-1.27v-1c0-2.92-2.54-5.21-5.85-5.21h-188c-3.31 0-5.73 2.29-5.73 5.21v1c-.03.3.01.61.13.89a7.984 7.984 0 00-1.27 4.32v165.39a6.41 6.41 0 00-2 4.7v11.06H72a4.328 4.328 0 00-4.53 4.12 4.328 4.328 0 004.12 4.53c.14.01.28.01.42 0h217.42a4.328 4.328 0 004.12-4.53 4.353 4.353 0 00-4.13-4.12zM94.14 76.97H265.9v81.8H94.79c-.22-.02-.43-.02-.65 0v-81.8zM265.9 242.36a6.41 6.41 0 00-2 4.7v11.06H96.17v-11.06a6.41 6.41 0 00-2-4.7v-72.14H265.9v72.14zM151.72 352.28c-3.6.05-7.17-.59-10.53-1.89a21.595 21.595 0 01-8.05-5.47 25.27 25.27 0 01-5.14-8.69 34.42 34.42 0 01-1.86-11.6v-39.69h12.42v40.38c-.02 2.06.26 4.1.83 6.08.5 1.74 1.35 3.37 2.49 4.78 1.12 1.36 2.53 2.45 4.14 3.17 1.79.8 3.74 1.19 5.7 1.15 1.99.05 3.97-.35 5.8-1.15 1.6-.73 3.02-1.81 4.14-3.17a13.56 13.56 0 002.48-4.78c.57-1.98.85-4.02.83-6.08v-40.38h12.42v39.69c.04 3.83-.56 7.64-1.8 11.27a24.714 24.714 0 01-5.15 8.74 23.458 23.458 0 01-8.09 5.66 27.087 27.087 0 01-10.63 1.98zM187.69 284.94h12.05v19.78l-.73 6.44h.73c1.26-2.05 3.04-3.74 5.16-4.88 2.65-1.42 5.63-2.11 8.64-2 2.84-.01 5.66.6 8.24 1.79 2.6 1.2 4.94 2.9 6.9 5a23.51 23.51 0 014.74 7.59 27.685 27.685 0 010 19.32 23.79 23.79 0 01-4.74 7.59c-1.96 2.09-4.3 3.79-6.9 5-2.58 1.19-5.4 1.8-8.24 1.79-3.01.1-5.99-.59-8.64-2-2.12-1.14-3.9-2.83-5.16-4.88H199v5.43h-11.31v-65.97zm23.37 56.21c1.56 0 3.11-.31 4.55-.92 1.43-.6 2.73-1.48 3.82-2.58 1.14-1.15 2.05-2.51 2.67-4 1.35-3.43 1.35-7.24 0-10.67-.62-1.51-1.53-2.88-2.67-4.05-1.1-1.1-2.39-1.97-3.82-2.57a11.67 11.67 0 00-4.55-.92c-1.56-.01-3.1.29-4.55.87-1.43.58-2.73 1.44-3.82 2.53a12.526 12.526 0 00-2.67 4 15.067 15.067 0 000 10.86c.62 1.5 1.53 2.85 2.67 4 1.08 1.1 2.39 1.96 3.82 2.53 1.44.6 2.99.92 4.55.92z" />
  </svg>
);

export const BB = (
  <svg viewBox="0 0 360 319" xmlSpace="preserve" fill="currentColor">
    <path d="M128.32 207.68h25.76A23 23 0 01162 209a20.3 20.3 0 016.39 3.68 17.56 17.56 0 014.28 5.48 15.94 15.94 0 01-1 15.5 16.55 16.55 0 01-6.3 5.38v.74a17.8 17.8 0 018.14 5.75 15.14 15.14 0 013.09 9.7 16.5 16.5 0 01-1.71 7.59 17.46 17.46 0 01-4.64 5.75 21.33 21.33 0 01-6.86 3.68 26.65 26.65 0 01-8.41 1.29h-26.66zm24.84 26.86a9 9 0 006.67-2.34 7.63 7.63 0 002.34-5.57 7.53 7.53 0 00-2.3-5.52 8.59 8.59 0 00-6.35-2.3h-12.78v15.73zm1.38 27.6c3.12 0 5.52-.78 7.17-2.34a7.93 7.93 0 002.49-6 8.18 8.18 0 00-2.53-6.12c-1.69-1.62-4.19-2.44-7.5-2.44h-13.43v16.93zM184.71 207.68h12v19.78l-.71 6.44h.73a13.7 13.7 0 015.16-4.88 17 17 0 018.64-2 19.62 19.62 0 018.24 1.79 22.17 22.17 0 016.9 5 23.82 23.82 0 014.74 7.59 27.68 27.68 0 010 19.32 23.82 23.82 0 01-4.74 7.59 22.17 22.17 0 01-6.9 5 19.62 19.62 0 01-8.24 1.79 17 17 0 01-8.64-2 13.7 13.7 0 01-5.16-4.88H196v5.43h-11.29zm23.37 56.21a11.56 11.56 0 004.55-.92 11.83 11.83 0 003.82-2.58 12.38 12.38 0 002.67-4 14.62 14.62 0 000-10.68 12.38 12.38 0 00-2.67-4 11.83 11.83 0 00-3.82-2.58 11.56 11.56 0 00-4.55-.92 12.08 12.08 0 00-4.55.87 11.43 11.43 0 00-3.82 2.53 12.53 12.53 0 00-2.67 4.05 15.1 15.1 0 000 10.86 12.53 12.53 0 002.67 4.05 11.43 11.43 0 003.82 2.53 12.08 12.08 0 004.55.79z" />
    <path d="M186.5 187.24h-11.81a3.25 3.25 0 01-3.25-3.25V69.71a3.25 3.25 0 013.25-3.25h11.81a3.24 3.24 0 013.25 3.25V184a3.24 3.24 0 01-3.25 3.24z" />
    <path d="M185.62 73h-10.05a9.7 9.7 0 01-9.68-9.69V49.67a5.19 5.19 0 015.18-5.19h19.05a5.2 5.2 0 015.19 5.19v13.62a9.7 9.7 0 01-9.69 9.71zm-13.23-22v12.29a3.19 3.19 0 003.18 3.19h10.05a3.19 3.19 0 003.19-3.19V51zM288.7 189.65H71.8a4.49 4.49 0 010-9h216.9a4.49 4.49 0 010 9zm0-2.47z" />
  </svg>
);

export const BBnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M287.24,223.49h-99V114.89a9.7,9.7,0,0,0,5.55-8.75V92.51a5.19,5.19,0,0,0-5.18-5.18h-19a5.2,5.2,0,0,0-5.19,5.18v13.63a9.69,9.69,0,0,0,5.56,8.75v108.6H70.34a4.5,4.5,0,0,0,0,9h216.9a4.5,4.5,0,0,0,0-9ZM170.92,93.82h16.42v12.31a3.2,3.2,0,0,1-2.86,3.16l-.32,0h-10l-.33,0a3.19,3.19,0,0,1-2.86-3.16Z"
      transform="translate(-64.92 -46.04)"
    />
  </svg>
);

export const FXnoText = (
  <svg viewBox="0 0 348.25 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M178.29,215.5a4.21,4.21,0,0,1-1.85-.42L43.94,150.33a4.21,4.21,0,0,1,.85-7.88l133.05-32.79a4.23,4.23,0,0,1,2,0L314,142.72a4.21,4.21,0,0,1,.82,7.89L180.11,215.08A4.12,4.12,0,0,1,178.29,215.5ZM58,147.83l120.23,58.75,122.27-58.5-121.74-30Z"
      transform="translate(-5.26 -49.47)"
    />
    <path
      d="M178.22,231.19a4.32,4.32,0,0,1-1.93-.46L9.12,147.07a4.34,4.34,0,0,1,.93-8.1l168-40a4.23,4.23,0,0,1,2,0l168.66,39.94a4.34,4.34,0,0,1,.92,8.11L180.15,230.75A4.3,4.3,0,0,1,178.22,231.19ZM23.67,144.65,178.24,222,335,144.58,179,107.65Z"
      transform="translate(-5.26 -49.47)"
    />
  </svg>
);

export const HBnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M282.73,256.56h-6.61V245.5a6.41,6.41,0,0,0-2-4.7V53.4a7.86,7.86,0,0,0-1-3.94,2.19,2.19,0,0,0,.25-1.28v-1c0-2.93-2.54-5.22-5.85-5.22h-188c-3.31,0-5.73,2.29-5.73,5.22v1a1.81,1.81,0,0,0,.13.89,7.91,7.91,0,0,0-1.27,4.33V240.8a6.41,6.41,0,0,0-2,4.7v11.06H65.31a4.33,4.33,0,0,0-.41,8.65,2.94,2.94,0,0,0,.42,0H282.74a4.33,4.33,0,0,0,0-8.65ZM259.21,240.8a6.41,6.41,0,0,0-2,4.7v11.06H89.48V245.5a6.41,6.41,0,0,0-2-4.7V53.4H259.21V240.8Z"
      transform="translate(-59.95 -39.72)"
    />
  </svg>
);

export const PBnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M289.74,248.36a4.29,4.29,0,0,1-4.26,4.32H67.89a4.32,4.32,0,1,1,0-8.64h65L131.71,136.7a8.79,8.79,0,0,1,5.34-8.13l.25-53a52.43,52.43,0,0,1,2.16-9l.64-2.16a3.86,3.86,0,0,0,.25-1,12.35,12.35,0,0,1-2.28-7.24c0-6.36,4.45-11.45,9.91-11.45s9.92,5.09,9.92,11.45a11.74,11.74,0,0,1-4.57,9.53c-.12.26-.12.64-.25.89l-.76,2.67a55.14,55.14,0,0,0-1.91,7.38l-.13,2.79v48.82a8.85,8.85,0,0,1,6.61,8.52L158,244.08h37.29l1.09-107.38a8.84,8.84,0,0,1,6.74-8.52l-.25-51.87c-.39-2.29-1.28-5.08-1.91-7.37l-.76-2.16c-.13-.38-.13-.77-.26-1.15a12,12,0,0,1-4.45-9.53c0-6.36,4.45-11.45,9.92-11.45s9.92,5.09,9.92,11.45A12.17,12.17,0,0,1,213,63.47c.13.13.13.38.25.64l.77,2.54a71.47,71.47,0,0,1,2.16,8.65l.25,3.3v50.1a8.86,8.86,0,0,1,5.22,8L220.45,244h65a4.28,4.28,0,0,1,4.29,4.27Z"
      transform="translate(-62.78 -34.79)"
    />
  </svg>
);

export const PHnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M276.91,215.48H233.82V181.91a10,10,0,0,0-4.45-8.26V128.78h8.26a25.66,25.66,0,0,0,17.93-7.38,25,25,0,0,0,7.37-17.67V89.87a5.69,5.69,0,0,0-5.66-5.72h-53V68.39c0-2.42.8-7.89-7.6-8.14h-1c-8.52.25-7.81,5.72-7.81,8.14V84.15H151.7V68.39c0-2.42.36-7.89-8.16-8.14h-1c-8.39.25-7.84,5.72-7.84,8.14V84.15H79.1a5.67,5.67,0,0,0-5.59,5.72v13.86a24.49,24.49,0,0,0,7.31,17.67,25.09,25.09,0,0,0,17.8,7.38h8.52V174a9.44,9.44,0,0,0-4.07,7.88v33.57H59.38a4.32,4.32,0,1,0,0,8.64H276.91a4.32,4.32,0,0,0,0-8.64ZM98.66,120A16,16,0,0,1,87,115.17a15.71,15.71,0,0,1-4.83-11.44V92.92h172v10.81a16.07,16.07,0,0,1-4.7,11.44A16.54,16.54,0,0,1,237.6,120Zm114.52,53.9a9.78,9.78,0,0,0-4.19,8v33.58H128V181.91a9.74,9.74,0,0,0-4.58-8.26V128.78h89.8Z"
      transform="translate(-54.28 -28.31)"
    />
  </svg>
);

export const SRnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M159.07,212.88V90.7A9.93,9.93,0,0,0,157.8,86V82.06a4.29,4.29,0,0,0-4.25-4.33h-.45V61.84a1.87,1.87,0,0,0-1.84-1.9h-.07a2,2,0,0,0-1.9,1.9V77.73H149A4.29,4.29,0,0,0,144.71,82v4a10,10,0,0,0-1.27,4.7V212.88a25.88,25.88,0,1,0,15.63,0Zm-7.88,41.58a17,17,0,0,1-5.08-33.31,4,4,0,0,0,1.27.25h7.75a4.74,4.74,0,0,0,1.4-.25h.13a17.07,17.07,0,0,1-5.47,33.31Z"
      transform="translate(-66.04 -47.81)"
    />
    <path
      d="M216.41,213V90.7a7.46,7.46,0,0,0-1.27-4.32V82.06a4.29,4.29,0,0,0-4.25-4.33h-.45V61.84a1.91,1.91,0,0,0-3.82,0V77.73h-.38A4.29,4.29,0,0,0,201.92,82v4.39a7.46,7.46,0,0,0-1.27,4.32V212.88a26.15,26.15,0,1,0,15.76.13Zm-7.87,41.45a17,17,0,0,1-5.21-33.31,5.49,5.49,0,0,0,1.4.25h7.63a7.2,7.2,0,0,0,1.52-.25H214a17.07,17.07,0,0,1-5.47,33.31Z"
      transform="translate(-66.04 -47.81)"
    />
  </svg>
);

export const UBnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M288.63,255.3H282V244.24a6.45,6.45,0,0,0-2-4.7V74.15a8.07,8.07,0,0,0-1-3.94,2.16,2.16,0,0,0,.25-1.27v-1c0-2.92-2.54-5.21-5.85-5.21h-188c-3.31,0-5.73,2.29-5.73,5.21v1a1.81,1.81,0,0,0,.13.89,7.9,7.9,0,0,0-1.27,4.32V239.54a6.41,6.41,0,0,0-2,4.7V255.3H71.21a4.33,4.33,0,1,0-.42,8.65H288.63a4.33,4.33,0,0,0,0-8.65ZM93.35,74.15H265.11V156H94a3.53,3.53,0,0,0-.65,0ZM265.11,239.54a6.41,6.41,0,0,0-2,4.7V255.3H95.38V244.24a6.41,6.41,0,0,0-2-4.7V167.4H265.11Z"
      transform="translate(-65.84 -49.47)"
    />
  </svg>
);

export const VTnoText = (
  <svg viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="currentColor">
    <path
      d="M286.84,226.58H223.52v-8.64a14.11,14.11,0,0,0-14-14h-5.85V141.28h18.58a18.06,18.06,0,0,0,18.06-17.68V72.75a4.29,4.29,0,0,0-4.26-4.32H120.42a4.37,4.37,0,0,0-4.33,4.32v50.6a18,18,0,0,0,18.06,17.93h21.1v61.91a1.53,1.53,0,0,0,.13.76h-7a14,14,0,0,0-14,14h0v8.64H69.31a4.39,4.39,0,0,0,0,8.78H134.4v1.52a4.29,4.29,0,0,0,4.25,4.33H219.2a4.37,4.37,0,0,0,4.32-4.33v-1.52h63.32a4.39,4.39,0,1,0,0-8.78ZM124.75,77.08H231.66v10.8l-106.91-.26Zm9.41,55.56a9.44,9.44,0,0,1-9.41-9.28v-27l106.92.12v27a9.34,9.34,0,0,1-9.41,9.15Zm80.59,99.92h-71.7V217.94a5.26,5.26,0,0,1,5.31-5.21h61.18a5.16,5.16,0,0,1,5.21,5.11v14.72Z"
      transform="translate(-64.2 -40.95)"
    />
  </svg>
);

export const sCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="currentColor"
    width="1em"
    height="1em"
  >
    <path d="m32 2c-16.568 0-30 13.431-30 30 0 16.569 13.432 30 30 30s30-13.432 30-30c0-16.569-13.432-30-30-30m8.953 42.678c-2.049 1.752-4.943 2.627-8.684 2.627-3.82 0-6.826-.863-9.014-2.588-2.189-1.727-3.283-4.098-3.283-7.117h5.787c.188 1.326.557 2.316 1.105 2.973 1.006 1.195 2.727 1.791 5.166 1.791 1.461 0 2.646-.156 3.557-.473 1.73-.604 2.594-1.725 2.594-3.365 0-.957-.424-1.699-1.27-2.225-.848-.512-2.191-.965-4.029-1.357l-3.141-.689c-3.088-.684-5.209-1.424-6.363-2.224-1.957-1.339-2.934-3.432-2.934-6.28 0-2.599.957-4.757 2.869-6.476 1.912-1.72 4.723-2.579 8.43-2.579 3.096 0 5.734.81 7.922 2.431 2.184 1.621 3.33 3.974 3.438 7.058h-5.828c-.107-1.745-.887-2.985-2.34-3.721-.969-.485-2.174-.729-3.613-.729-1.602 0-2.879.315-3.834.945s-1.434 1.509-1.434 2.638c0 1.037.471 1.811 1.414 2.322.604.342 1.889.742 3.855 1.201l5.092 1.201c2.23.524 3.904 1.227 5.018 2.105 1.729 1.365 2.594 3.341 2.594 5.925 0 2.651-1.023 4.854-3.074 6.606" />
  </svg>
);

export const nCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="currentColor"
    width="1em"
    height="1em"
  >
    <path d="M32,2C15.432,2,2,15.432,2,32s13.432,30,30,30s30-13.432,30-30S48.568,2,32,2z M43.762,46.508h-6.061L25.889,25.92v20.588h-5.65V17.492h6.357l11.518,20.231V17.492h5.648V46.508z" />
  </svg>
);

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-search"
    viewBox="0 0 16 16"
  >
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
  </svg>
);

export const scoreboardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-list-ol"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
    />
    <path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z" />
  </svg>
);

export const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
  </svg>
);

export const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-download"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
  </svg>
);

export const screenshotIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-aspect-ratio"
    viewBox="0 0 16 16"
  >
    <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
    <path d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z" />
  </svg>
);

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-pencil-square"
    viewBox="0 0 16 16"
  >
    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
    <path
      fillRule="evenodd"
      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
    />
  </svg>
);

export const linkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-link"
    viewBox="0 0 16 16"
  >
    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z" />
  </svg>
);

export const chevronLeftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-chevron-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
    />
  </svg>
);

export const chevronRightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-chevron-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
    />
  </svg>
);

export const discordIcon = (
  <svg
    width="71"
    height="55"
    viewBox="0 0 71 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z"
        fill="#5865F2"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="71" height="55" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const youtubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    width="32"
    fill="currentColor"
    viewBox="-35.20005 -41.33325 305.0671 247.9995"
  >
    <path d="M229.763 25.817c-2.699-10.162-10.65-18.165-20.747-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.554 7.652 7.602 15.655 4.904 25.817 0 44.237 0 82.667 0 82.667s0 38.43 4.904 56.85c2.698 10.162 10.65 18.164 20.747 20.881 18.3 4.935 91.682 4.935 91.682 4.935s73.383 0 91.683-4.935c10.097-2.717 18.048-10.72 20.747-20.88 4.904-18.422 4.904-56.851 4.904-56.851s0-38.43-4.904-56.85" />
    <path d="M93.333 117.558l61.334-34.89-61.334-34.893z" fill="#fff" />
  </svg>
);

export const videoCameraIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-camera-video"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
    />
  </svg>
);

export const scissorsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-scissors"
    viewBox="0 0 16 16"
  >
    <path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
  </svg>
);

export const timerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-stopwatch"
    viewBox="0 0 16 16"
  >
    <path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z" />
    <path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z" />
  </svg>
);

export const printIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    className="bi bi-printer"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
  </svg>
);

export const pdfIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    className="bi bi-filetype-pdf"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    />
  </svg>
);

export const cardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-card-text"
    viewBox="0 0 16 16"
  >
    <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
    <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8m0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5" />
  </svg>
);
